import { Injectable } from '@angular/core';
import { OclGroupService } from '../../../ocl/services/ocl-group-service/ocl-group.service';
import { GocModuleConfigService } from '../goc-module-config/goc-module-config.service';
import { OclGroupsStoreManager } from '../../../ocl/store/groups/ocl-groups.store-manager';
import { RequestService } from '../../../common/services/request.service';
import { PollingService } from '../../../common/services/polling/polling.service';

@Injectable({
  providedIn: 'root',
})
export class GocGroupService extends OclGroupService {
  // tslint:disable:variable-name
  ParseEventGroup = Parse.Object.extend('GOCEventGroup');
  ParseDecisionGroup = Parse.Object.extend('GOCDecisionGroup');
  ParseLogbookGroup = Parse.Object.extend('GOCLogBookGroup');
  ParseGlobalInstructionGroup = Parse.Object.extend('GOCGlobalInstructionGroup');
  ParseEvent = Parse.Object.extend('GOCEvents');
  ParseDecisions = Parse.Object.extend('GOCDecisions');
  ParseLogbook = Parse.Object.extend('GOCLogBook');
  ParseGlobalInstruction = Parse.Object.extend('GOCGlobalInstruction');

  // tslint:enable

  protected constructor(
    protected requestService: RequestService,
    protected groupStoreManager: OclGroupsStoreManager,
    protected moduleConfig: GocModuleConfigService,
  ) {
    super(requestService, groupStoreManager, moduleConfig);
  }
}
